export enum NeufModulePathEnum {
  dashboard = 'dashboard',
  salePlan = 'sale-plan',
  freeStratalots = 'free-stratalots',
  prospects = 'prospects',
  validateOffer = 'validate-offer',
  salesInProgress = 'sales-in-progress',
  programCommercialisation = 'programmes-commercialisation'
}
